import { initialNavigationState, NavigationState } from '../navigation/navigation.state'


export type CMSFooterState = {
  menuItems: NavigationState
}

export const initialCMSFooterState: CMSFooterState = {
  menuItems: initialNavigationState
}
